// Create a new router instance
import { createRouter } from '@tanstack/react-router'

import { initLogger } from '@/lib/logger.ts'
import { useAppUpdateStore } from '@/hooks/use-update-app.ts'
import { routeTree } from '@/routeTree.gen.ts'

export const router = createRouter({
  routeTree,
  context: {},
  defaultPreload: 'intent',
  scrollRestoration: true,
  scrollRestorationBehavior: 'auto',
  scrollToTopSelectors: [
    'window',
    "[data-scroll-restoration-id='layout-scroll-container']",
  ],
  defaultStructuralSharing: true,
  defaultPreloadStaleTime: 0,
})

const log = initLogger('UpdateApp')
router.subscribe('onResolved', (evt) => {
  if (
    useAppUpdateStore.getState().hadUpdateAt &&
    evt.fromLocation?.pathname !== evt.toLocation.pathname
  ) {
    log.info('Updating app')

    window.location.reload()
  }
})

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}
